var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('breadcrumbs',{attrs:{"breadcrumbs":[
				{ label: 'Assistenza', link: '/assistenza' },
				{ label: 'Contatta un esperto', link: null }
			]}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"uk-section uk-section-xsmall"},[_c('div',{staticClass:"uk-container uk-container-large"},[_c('h1',{staticClass:"h3"},[_vm._v("Parla con un esperto online in meno di 24 ore")]),_c('div',{attrs:{"id":"kd-widget"}})])])
}]

export { render, staticRenderFns }